var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whitespace-nowrap flex items-center"},_vm._l((_vm.zoneColors),function(color,idx){return _c('div',{key:idx,staticClass:"rounded-full mr-1",class:[color, _vm.mini ? 'w-2 h-2' : 'w-5 h-5']})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }